import update from "immutability-helper";
import type { AnyAction } from "redux";
import type { Story, Folder, MemberOfFolder } from "@theirstory/common/api_types/backend";

import {
  FOLDERS_RESET_CURRENT,
  FOLDERS_LOADED,
  FOLDER_DETAILS_LOADED,
  FOLDER_STORIES_LOADED,
  FOLDER_STORIES_LOADING,
  // FOLDER_SEARCH_PARAM,
  FOLDER_STORIES_PARTIAL_UPDATE,
  FOLDER_STORIES_SET_PAGE_VIEW,
  STORIES_ONE_UPDATED,
  FOLDER_STORIES_SORT_SETTING,
  FOLDER_STORIES_FILTER_SETTING,
  FOLDERS_LOADING,
  FOLDERS_TOGGLE_CREATE_FOLDER_MODAL,
  RESET_FOLDER_STATE,
  RESET_FOLDER_STORIES,
} from "../actions/types";
import type { FoldersLoaded } from "../actions/folders";
import type { ProjectStoriesFilters } from "../actions/projects";

export interface FolderPreview {
  _id: string;
  name: string;
  numberOfStories: number;
}

export interface ProjectsState {
  projectFolders: Folder[];
  isOpenCreateModal: boolean;
  folder: {
    folderId: string;
    folderDetails: any;
    name: string;
    description: string;
    creator: string;
    membersOfFolder: MemberOfFolder[];
    created_at: string;
    defaultFolderForProject: boolean;
    numberOfStories: number;
    stories: Story[];
    paging: {
      size: number;
      current: number;
      count: number;
      totalItems: number;
    };
    sort: {
      column: string;
      order: "asc" | "desc";
    };
    filters?: ProjectStoriesFilters | null;
    searchParam: string;
    isLoading: boolean;
  };
  isLoading: boolean;
}

const initialState: ProjectsState = {
  projectFolders: [],
  isOpenCreateModal: false,
  folder: {
    folderId: null,
    name: null,
    description: null,
    creator: null,
    membersOfFolder: [],
    created_at: null,
    defaultFolderForProject: false,
    numberOfStories: 0,
    folderDetails: {},
    stories: [],
    paging: {
      size: 15,
      current: 1,
      count: 1,
      totalItems: 0,
    },
    sort: {
      column: null,
      order: null,
    },
    filters: null,
    searchParam: null,
    isLoading: false,
  },
  isLoading: false,
};

const foldersReducer = (state = initialState, { type, payload }: AnyAction) => {
  switch (type) {
    case FOLDERS_LOADED: {
      return update(state, { projectFolders: { $set: payload as FoldersLoaded }, isLoading: { $set: false } });
    }
    case FOLDER_DETAILS_LOADED:
      return update(state, {
        folder: {
          folderDetails: { $set: payload.folderDetails },
        },
      });
    case FOLDER_STORIES_LOADING:
      return update(state, {
        folder: {
          isLoading: { $set: true },
        },
      });
    case FOLDERS_LOADING:
      return update(state, {
        isLoading: { $set: true },
      });
    case FOLDER_STORIES_LOADED:
      return update(state, {
        folder: {
          folderId: { $set: payload.folderId },
          stories: { $set: payload.stories },
          paging: {
            current: { $set: payload.page },
            count: { $set: Math.ceil(payload.total / state.folder.paging.size) },
            totalItems: { $set: payload.total },
          },
          isLoading: { $set: false },
        },
      });
    // case FOLDER_SEARCH_PARAM:
    //   return update(state, {
    //     folder: {
    //       searchParam: { $set: payload.searchParam },
    //     },
    //   });
    case FOLDER_STORIES_PARTIAL_UPDATE:
      return update(state, {
        folder: {
          stories: (s) => s.map((i) => (i._id !== payload._id ? i : update(i, { $merge: payload }))),
        },
      });
    case STORIES_ONE_UPDATED:
      return update(state, {
        folder: {
          stories: (s) => s.map((i) => (i._id !== payload._id ? i : payload)),
        },
      });
    case FOLDER_STORIES_SET_PAGE_VIEW: {
      const { currentPage, pageSize } = payload;
      return update(
        state,
        pageSize != null
          ? {
              folder: {
                paging: {
                  size: { $set: pageSize },
                  current: { $set: currentPage != null ? currentPage : 1 },
                },
              },
            }
          : currentPage == null
          ? {}
          : { folder: { paging: { current: { $set: currentPage } } } }
      );
    }
    case FOLDER_STORIES_SORT_SETTING: {
      const { column, order } = payload;
      return update(state, {
        folder: {
          sort: {
            column: { $set: column },
            order: { $set: order },
          },
        },
      });
    }
    case FOLDER_STORIES_FILTER_SETTING: {
      return update(state, {
        folder: {
          filters: { $set: payload.filters },
          paging: { current: { $set: 1 }, totalItems: { $set: 0 } },
        },
      });
    }
    case FOLDERS_RESET_CURRENT: {
      return update(state, {
        projectFolders: { $set: initialState.projectFolders },
      });
    }
    case FOLDERS_TOGGLE_CREATE_FOLDER_MODAL: {
      return update(state, {
        isOpenCreateModal: { $set: payload.isOpen },
      });
    }
    case RESET_FOLDER_STORIES: {
      return update(state, {
        folder: {
          stories: { $set: initialState.folder.stories },
        },
      });
    }
    case RESET_FOLDER_STATE: {
      return initialState;
    }
    default:
      return state;
  }
};

export default foldersReducer;
